import Enum from './Enum.js';

export default class UserType extends Enum {
  static STAFF = new UserType('STAFF', 'スタッフ');
  static MANAGER = new UserType('MANAGER', 'マネージャー');
  static DEPARTMENT_MANAGER = new UserType('DEPARTMENT_MANAGER', '店長');
}
